import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ReactComponent as DeleteRedIcon } from "../../assets/icons/delete-red-icon.svg";
import {
  DELETE_DELIVERY_ADDRESS,
  LIST_DELIVERY_ADDRESS,
  USER_LOGOUT,
} from "../../Redux/SagaAction/actions";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { myaddress } from "../../config/RoutingConsts";

const DeleteModal = ({
  showDeleteModal,
  myAddress,
  logout,
  setshowDeleteModal,
  deleteId,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleClose = () => setshowDeleteModal(false);
  const { t } = useTranslation();

  const handleSubmit = () => {
    if (logout) {
      dispatch({ type: USER_LOGOUT});
      setshowDeleteModal(false)
      navigate("/");
    }
    if (myAddress) {
      dispatch({
        type: DELETE_DELIVERY_ADDRESS,
        payload: { addressId: deleteId },
        callback: () => {
            dispatch({type:LIST_DELIVERY_ADDRESS})
            setshowDeleteModal(false)
        },
      });
    }
  };
  return (
    <>
      <Modal
        show={showDeleteModal}
        onHide={()=> setshowDeleteModal(false)}
        centered
        className="custom-modal"
        data-dismiss="modal"
        data-toggle="modal"
        id="Delete"
        autoFocus
        backdrop="static"
        // keyboard={false}
      >
        <Modal.Body>
          <div className="delete-content">
            <div className="icon-wrapper">
              <DeleteRedIcon />
            </div>
            <div className="title">
              {logout
                ? "Are you sure? Do you want to logout?"
                : myAddress ? "Are you sure? Do you want to Remove Delivery Address" : "Do you want to delete your address?"}
            </div>
            <div className="button-wrapper">
              <button
                type="submit"
                className="common-btn border-btn"
                onClick={()=> setshowDeleteModal(false)}
              >
                No
              </button>
              <button
                type="submit"
                className="common-btn"
                onClick={handleSubmit}
              >
                Yes
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DeleteModal;
